// «Трекер задач» for field engineers (KOP-40 spec §7). The guard only drives navigation;
// server RBAC is the security boundary.
import { ACCESS, hasAccess, readAccessItems } from '@/components/management/dispatcher/access';

export function buildFieldTasksRoute({ page, readItems = readAccessItems }) {
  return {
    path: '/field/tasks',
    name: 'field-tasks',
    component: page,
    beforeEnter(to, from, next) {
      if (hasAccess(readItems(), ACCESS.ENGINEER)) return next();
      return next('/');
    },
  };
}

export default buildFieldTasksRoute({ page: () => import('../views/pages/field/FieldTasksPage.vue') });
